import { Module } from "src/state/Module"
import * as Types from "src/state/gql/_types"

export const UserModule = new Module<Types.UserFragment, Types.GetUsersQueryVariables, Types.Users_Insert_Input>({
    sortKey: 'email',
    orderBy: {
        'email': 'asc'
    }
})